export enum TaskStatuses {
  DRAFT = "DRAFT",
  SUBMITTED = "SUBMITTED",
  REVIEW = "REVIEW",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  PUBLISHING = "PUBLISHING",
  PUBLISHED = "PUBLISHED",
}
